import { Link, useLocation } from 'react-router';
import { t } from '../i18n';
import { navItems } from './navigation';

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const current = navItems.find((item) => item.to === pathname);

  return (
    <nav aria-label={t('breadcrumb.label')} className="text-sm text-slate-600">
      <ol className="flex items-center gap-2">
        <li>
          <Link to="/" className="hover:underline">
            {t('breadcrumb.home')}
          </Link>
        </li>
        {current && current.to !== '/' && (
          <li aria-current="page" className="flex items-center gap-2">
            <span aria-hidden="true">/</span>
            <span>{t(current.labelKey)}</span>
          </li>
        )}
      </ol>
    </nav>
  );
}
